/* eslint-disable import/prefer-default-export */
import { BackMappings } from './BackMappings';
import { CookieHelper } from './CookieHelper';
import { GtmConstants } from './GtmConstants';
import { GtmManager } from './GtmManager';

const WEB_ECOMMERCE_BOT = 'web_ecommerce_bot';

const APP_CLUB = 'app_club';

const APP = 'app_club';

const APP_MCOMMERCE = 'app_mcommerce';

export class StorageHelper {
  static setGibraltar = (isGibraltar: any) => {
    if (isGibraltar) {
      sessionStorage.setItem('isGibraltar', 'true');
    } else {
      sessionStorage.setItem('isGibraltar', 'false');
    }
  };

  static isGibraltar = () => {
    return sessionStorage.getItem('isGibraltar') === 'true';
  };

  static setAndorra = (isAndorra: any) => {
    if (isAndorra) {
      sessionStorage.setItem('isAndorra', 'true');
    } else {
      sessionStorage.setItem('isAndorra', 'false');
    }
  };

  static isAndorra = () => {
    return sessionStorage.getItem('isAndorra') === 'true';
  };

  static setGoneToImpagos = () => {
    sessionStorage.setItem('goneToImpagos', 'true');
  };

  static removeGoneToImpagos = () => {
    sessionStorage.removeItem('goneToImpagos');
  };

  static isGoneToImpagos = () => {
    const gone = sessionStorage.getItem('goneToImpagos');
    return gone !== null && gone !== undefined;
  };

  static setOpenV2PFromOro = () => {
    sessionStorage.setItem('oro-v2p-error', 'true');
  };

  static getOpenV2PFromOro = () => {
    return sessionStorage.getItem('oro-v2p-error');
  };

  static removeOpenV2PFromOro = () => {
    sessionStorage.removeItem('oro-v2p-error');
  };

  static setOpenOroPersonalData = () => {
    sessionStorage.setItem('oro-error', 'true');
  };

  static getOpenOroPersonalData = () => {
    return sessionStorage.getItem('oro-error');
  };

  static removeOpenOroPersonalData = () => {
    sessionStorage.removeItem('oro-error');
  };

  static setOpenPersonalData = () => {
    sessionStorage.setItem('openPersonalData', 'true');
  };

  static removeOpenPersonalData = () => {
    sessionStorage.removeItem('openPersonalData');
  };

  static isOpenPersonalData = () => {
    const open = sessionStorage.getItem('openPersonalData');
    return open !== null && open !== undefined;
  };

  static setOpenDireccionHabitual = () => {
    sessionStorage.setItem('openDireccionHabitual', 'true');
  };

  static removeOpenDireccionHabitual = () => {
    sessionStorage.removeItem('openDireccionHabitual');
  };

  static isOpenDireccionHabitual = () => {
    const open = sessionStorage.getItem('openDireccionHabitual');
    return open !== null && open !== undefined;
  };

  static setTpvResponseMessage = (tpvResponseMessage: string) => {
    sessionStorage.setItem('tpvResponseMessage', tpvResponseMessage);
  };

  static setScrollBaja = (scrollBaja: string) => {
    sessionStorage.setItem('scrollBaja', scrollBaja);
  };

  static setScrollSuscripciones = (scrollSuscripciones: string) => {
    sessionStorage.setItem('scrollSuscripciones', scrollSuscripciones);
  };

  static setScrollPreferencia = (scrollPreferencia: string) => {
    sessionStorage.setItem('scrollPreferencia', scrollPreferencia);
  };

  static setScrollAbrirFacturacion = (scrollAbrirFacturacion: string) => {
    sessionStorage.setItem('scrollAbrirFacturacion', scrollAbrirFacturacion);
  };

  static setScrollFacturacion = (scrollFacturacion: string) => {
    sessionStorage.setItem('scrollFacturacion', scrollFacturacion);
  };

  static setExpiredSessionUrl = (expiredSessionUrl: string) => {
    sessionStorage.setItem('expiredSessionUrl', expiredSessionUrl);
  };

  static setFromUrl = (fromUrl: string) => {
    sessionStorage.setItem('fromUrl', fromUrl);
  };

  static setFromApp = (fromApp: string) => {
    sessionStorage.setItem('fromApp', fromApp);
  };

  static setOrigin = (origin: string) => {
    sessionStorage.setItem('origin', origin);
  };

  static getExpiredSessionUrl = () => {
    return sessionStorage.getItem('expiredSessionUrl');
  };

  static getFromUrl = () => {
    return sessionStorage.getItem('fromUrl');
  };

  static getFromApp = () => {
    return sessionStorage.getItem('fromApp');
  };

  static getOrigin = () => {
    return sessionStorage.getItem('origin');
  };

  static setSolicitudOroOrigin = (origin: string) => {
    sessionStorage.setItem('oroOrigin', origin);
  };

  static getSolicitudOroOrigin = () => {
    return sessionStorage.getItem('oroOrigin');
  };

  static getTpvResponseMessage = () => {
    return sessionStorage.getItem('tpvResponseMessage');
  };

  static getScrollBaja = () => {
    return sessionStorage.getItem('scrollBaja');
  };

  static getScrollSuscripciones = () => {
    return sessionStorage.getItem('scrollSuscripciones');
  };

  static getScrollPreferencia = () => {
    return sessionStorage.getItem('scrollPreferencia');
  };

  static getScrollAbrirFacturacion = () => {
    return sessionStorage.getItem('scrollAbrirFacturacion');
  };

  static getScrollFacturacion = () => {
    return sessionStorage.getItem('scrollFacturacion');
  };

  static removeSolicitudOroOrigin = () => {
    sessionStorage.removeItem('oroOrigin');
  };

  static removeTpvResponseMessage = () => {
    return sessionStorage.removeItem('tpvResponseMessage');
  };

  static removeScrollBaja = () => {
    return sessionStorage.removeItem('scrollBaja');
  };

  static removeScrollSuscripciones = () => {
    return sessionStorage.removeItem('scrollSuscripciones');
  };

  static removeScrollPreferencia = () => {
    return sessionStorage.removeItem('scrollPreferencia');
  };

  static removeScrollAbrirFacturacion = () => {
    return sessionStorage.removeItem('scrollAbrirFacturacion');
  };

  static removeScrollFacturacion = () => {
    return sessionStorage.removeItem('scrollFacturacion');
  };

  static setNuevaDireccionEntrega = (nuevaDireccionEntrega: string) => {
    sessionStorage.setItem('nuevaDireccionEntrega', nuevaDireccionEntrega);
  };

  static getNuevaDireccionEntrega = () => {
    return sessionStorage.getItem('nuevaDireccionEntrega');
  };

  static removeNuevaDireccionEntrega = () => {
    return sessionStorage.removeItem('nuevaDireccionEntrega');
  };

  static isThereTpvResponseMessage = () => {
    const tpvMessage = sessionStorage.getItem('tpvResponseMessage');
    return tpvMessage !== null && tpvMessage !== undefined;
  };

  static deleteUserFromSession = () => {
    sessionStorage.removeItem('tipoUsuarioTarjeta');
    sessionStorage.removeItem('tipoUsuarioTarjetaOro');
  };

  static setForzeSinTarjetas = () => {
    sessionStorage.setItem('forzeSinTarjetas', 'true');
  };

  static removeForzeSinTarjetas = () => {
    sessionStorage.removeItem('forzeSinTarjetas');
  };

  static isForzeSinTarjetas = () => {
    return sessionStorage.getItem('forzeSinTarjetas') === 'true';
  };

  static setUrlInterna = () => {
    sessionStorage.setItem('urlInterna', 'true');
  };

  static removeUrlInterna = () => {
    sessionStorage.removeItem('urlInterna');
  };

  static isUrlInterna = () => {
    return sessionStorage.getItem('urlInterna') === 'true';
  };

  static initializeVars = () => {
    if (sessionStorage.getItem('numCuponesAct') === null)
      sessionStorage.setItem('numCuponesAct', '0');
    if (sessionStorage.getItem('showCuponesAct') === null)
      sessionStorage.setItem('showCuponesAct', '0');
    if (sessionStorage.getItem('sessionVales') === null)
      sessionStorage.setItem('sessionVales', '0');
  };

  static initializeRevistasVars = () => {
    sessionStorage.setItem('yearRevistas', String(0));
    sessionStorage.setItem('revistaSelect', String('no-select'));
  };

  static removeSessionVars = () => {
    sessionStorage.removeItem('sessionVales');
    sessionStorage.removeItem('numCuponesAct');
    sessionStorage.removeItem('showCuponesAct');
  };

  static isTipoTarjetaUsuarioInSession = () => {
    return (
      sessionStorage.getItem('tipoUsuarioTarjeta') !== null &&
      sessionStorage.getItem('tipoUsuarioTarjeta') !== undefined
    );
  };

  static isTipoTarjetaUsuarioOroInSession = () => {
    return (
      sessionStorage.getItem('tipoUsuarioTarjetaOro') !== null &&
      sessionStorage.getItem('tipoUsuarioTarjetaOro') !== undefined
    );
  };

  static setOpenFormOro = () => {
    sessionStorage.setItem('open-form-oro', 'true');
  };

  static removeOpenFormOro = () => {
    sessionStorage.removeItem('open-form-oro');
  };

  static isOpenFormOro = () => {
    return sessionStorage.getItem('open-form-oro') === 'true';
  };

  static loadOroDataEvent = (
    value: string,
    title = '',
    click_name: string = GtmConstants.MENU_NONE,
  ) => {
    StorageHelper.setSolicitudOroOrigin(value);
    GtmManager.sendAComportamientoEvent({
      event: GtmConstants.GOLD_CARD_ITERATION,
      click_element:
        value === BackMappings.TARJETA_MENU_ORO
          ? GtmConstants.MENU_ACTION
          : GtmConstants.MENU_ACTION_CTA,
      category: GtmConstants.GOLD_CARD,
      click_title:
        value === BackMappings.TARJETA_MENU_ORO
          ? GtmConstants.MENU_NONE
          : title,
      click_name: click_name,
      section: 'none',
    });
  };

  static deleteUserFromSessionAndRedirect = (
    data: any,
    languaje: string,
    APP_BASE_URL: string | undefined,
    e: any,
  ) => {
    e.preventDefault();
    e.stopPropagation();
    if (data) {
      const origenAP = StorageHelper.getOrigenAPParameter(
        languaje,
        APP_BASE_URL,
      );
      const url = data?.url as string;
      // eslint-disable-next-line no-nested-ternary
      const location = data.externa
        ? url
        : url.includes('nlrRegistrar')
        ? StorageHelper.getLocationRegistrarBack(url, origenAP)
        : StorageHelper.getLocationTarjetasFront(
            languaje,
            url,
            data,
            APP_BASE_URL,
          );
      const openInNewWindow = data?.openInNewWindow as boolean;
      if (openInNewWindow) {
        window.open(location);
      } else {
        document.location.href = location;
      }
    }
  };

  static thereAreUserParams = (params: any) => {
    let hayParams = false;
    if (params) {
      const keys = Object.keys(params);
      if (keys.length > 0) {
        keys.forEach((key: string) => {
          if (
            !key.includes('utm') &&
            !key.includes('UTM') &&
            key !== '' &&
            key !== 'useMocks'
          ) {
            hayParams = true;
          }
        });
      }
    }
    return hayParams;
  };

  static getNoroLabel = () => {
    const label =
      sessionStorage.getItem('norolabel') !== null &&
      sessionStorage.getItem('norolabel') !== undefined
        ? sessionStorage.getItem('norolabel')
        : GtmConstants.MD_LABEL;
    return label !== null ? label : GtmConstants.MD_LABEL;
  };

  static setNoroLabel = (label: string) => {
    sessionStorage.setItem('norolabel', label);
  };

  static revomeNoroLabel = () => {
    sessionStorage.removeItem('norolabel');
  };

  static isApp = (params: any) => {
    return params.fromApp !== undefined &&
      params.fromApp !== null &&
      (params.fromApp === APP ||
        params.fromApp === APP_CLUB ||
        params.fromApp === APP_MCOMMERCE)
      ? 'true'
      : 'false';
  };

  static isEcommerceBot = () => {
    return sessionStorage.getItem('isEcommerceBot') === 'true';
  };

  static setEcommerceBot = (params: any) => {
    if (params.fromApp === WEB_ECOMMERCE_BOT) {
      sessionStorage.setItem('isEcommerceBot', 'true');
    }
  };

  private static getLocationTarjetasFront = (
    languaje: string,
    url: string,
    data: any,
    APP_BASE_URL?: string,
  ) => {
    if (data && data.solicitarOro) {
      StorageHelper.setNoroLabel(GtmConstants.ME_LABEL);
      StorageHelper.setOpenFormOro();
    }
    return `${APP_BASE_URL}/${languaje}${url}`;
  };

  private static getLocationRegistrarBack = (url: string, origenAP: string) => {
    StorageHelper.deleteUserFromSession();
    CookieHelper.removeUserCookies();
    return `${url}?origenAP=${origenAP}`;
  };

  private static getOrigenAPParameter(
    languaje: string,
    APP_BASE_URL: string | undefined,
  ) {
    let origenAP = window.location.href;
    if (APP_BASE_URL !== undefined) {
      origenAP = origenAP.replace(APP_BASE_URL, '');
    }
    const reg = new RegExp(`/${languaje}/`, 'g');
    origenAP = origenAP.replace(reg, '');
    return origenAP;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static setErrorManageOro(error: boolean, message: string) {
    sessionStorage.setItem('errorManageOro', String(error));
    sessionStorage.setItem('messageManageOro', message);
  }

  static getErrorManageOro() {
    const error = sessionStorage.getItem('errorManageOro');
    const message = sessionStorage.getItem('messageManageOro');
    return { error, message };
  }

  static removeErrorManageOro() {
    sessionStorage.removeItem('errorManageOro');
    sessionStorage.removeItem('messageManageOro');
  }
}
